module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title-p"
  }, [_c('span', [_vm._v("Praise for the Writing of Margery Sharp")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("“A highly gifted woman … a wonderful entertainer.” —"), _c('i', [_vm._v("The New Yorker")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("“One of the most gifted writers of comedy in the civilized world today.” —"), _c('i', [_vm._v("Chicago Daily News")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("“[Sharp’s] dialogue is brilliant, uncannily true. Her taste is excellent; she is an excellent storyteller.” —Elizabeth Bowen")]), _vm._v(" "), _c('p', {
    staticClass: "fm-p"
  }, [_vm._v("Britannia Mews")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("“As an artistic achievement … first-class, as entertainment … tops.” —"), _c('i', [_vm._v("The Boston Globe")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-p"
  }, [_vm._v("The Eye of Love")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("“A double-plotted … masterpiece.” —John Bayley, "), _c('i', [_vm._v("Guardian Books of the Year")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-p"
  }, [_vm._v("Martha, Eric, and George")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("“Amusing, enjoyable, Miss Sharp is a born storyteller.” —"), _c('i', [_vm._v("The Times")]), _vm._v(" (London)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-p"
  }, [_vm._v("The Gypsy in the Parlour")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("“Unforgettable … There is humor, mystery, good narrative.” —"), _c('i', [_vm._v("Library Journal")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-p"
  }, [_vm._v("The Nutmeg Tree")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("“A sheer delight.” —New York Herald Tribune")]), _vm._v(" "), _c('p', {
    staticClass: "fm-p"
  }, [_vm._v("Something Light")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("“Margery Sharp has done it again! Witty, clever, delightful, entertaining.” —"), _c('i', [_vm._v("The Denver Post")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f620084","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/praise.vue
// module id = 60
// module chunks = 0